import { render, staticRenderFns } from "./footer-links.vue?vue&type=template&id=6f52d5b6"
import script from "./footer-links.vue?vue&type=script&lang=ts"
export * from "./footer-links.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports